<script lang="ts">
	import { Eye, EyeOff } from 'lucide-svelte';
	import Input from './Input.svelte';

	type Props = {
		id: string;
		label: string;
		value?: string;
		name: string;
		error?: string | string[] | undefined;
		autocomplete?: HTMLInputElement['autocomplete'];
		placeholder?: string | undefined;
		success?: boolean;
		setValue?: (value: string) => void;
	};

	let {
		id,
		label,
		value = '',
		name,
		error,
		autocomplete = 'off',
		placeholder,
		success = false,
		setValue
	}: Props = $props();
	let showPassword = $state(false);

	function handleInput(event: Event) {
		const target = event.target as HTMLInputElement;
		error = undefined;
		setValue?.(target.value);
	}
</script>

<Input {error} {success}>
	<label for={id} class="input-label">{label}</label>
	<div class="flex gap-x-2">
		<div class="flex-1">
			<input
				{id}
				type={showPassword ? 'text' : 'password'}
				{name}
				{value}
				class="w-full"
				{autocomplete}
				{placeholder}
				oninput={handleInput}
			/>
		</div>
		<button type="button" onclick={() => (showPassword = !showPassword)}>
			{#if !showPassword}
				<Eye class="text-slate-500 dark:text-slate-500" />
			{:else}
				<EyeOff class="text-slate-500 dark:text-slate-500" />
			{/if}
		</button>
	</div>
</Input>
